import React, { useState, useEffect, useRef, Fragment } from "react";
import ButtonSwitcher from "../../../components/ButtonSwitcher";
import { tabs } from "../constants/selections";
import OfferType from "./OfferType";
import OfferContent from "./OfferContent";
import OfferScheduling from "./OfferScheduling";
import "./BroadcastOfferModal.css";

const BroadcastOfferModal = ({ type, selectedDate, onAdd, hex, white }) => {
  const [isPostable, setIsPostable] = useState(false);
  const [tab, setTab] = useState(tabs[0]);
  const [offer, setOffer] = useState({ type: "perk" });
  const dismissElement = useRef();

  useEffect(() => {
    if (offer.type && offer.attentionGrabber) setIsPostable(true);
    else setIsPostable(false);
  }, [offer]);
  const handleChangeTab = (tab) => {
    setTab(tab);
  };
  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleChangeContent = (content) => {
    setOffer({ ...offer, ...content });
  };
  const handleChangeType = (type) => {
    setOffer({ type: type, postNow: offer.postNow });
  };
  const handleClickBroadcast = () => {
    onAdd(offer);
  };
  return (
    <div
      className="modal fade broadcast_offer_modal"
      id="add_offer_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content broadcast_offer_modal">
          <div className="modal-header">
            <h5 className="modal-title">Broadcast an offer to feeds</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ButtonSwitcher
              buttonsGroup={tabs}
              currentTab={tab}
              onSwitch={handleChangeTab}
              hex={hex}
              white={white}
            />
            <OfferType
              type={type}
              onChangeType={handleChangeType}
              isVisible={tab === "Offer type" ? true : false}
            />
            <OfferContent
              offerType={(offer && offer.type) || "perk"}
              onChangeContent={handleChangeContent}
              isVisible={tab === "Content" ? true : false}
            />
            <OfferScheduling
              onChangeTime={handleChangeContent}
              selectedDate={selectedDate}
              isVisible={tab === "Scheduling" ? true : false}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Offer type" && (
                <button
                  type="button"
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": "black",
                    "--hover-color": "white",
                    backgroundColor: hex,
                    color: white ? "white" : "black",
                  }}
                  onClick={() => setTab("Content")}
                >
                  Next
                </button>
              )}
              {tab === "Content" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Offer type")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-hex btn-white"
                    style={{
                      "--hover-text-color": "black",
                      "--hover-color": "white",
                      backgroundColor: hex,
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Scheduling")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Scheduling" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Content")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!isPostable}
                    onClick={handleClickBroadcast}
                  >
                    Broadcast
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastOfferModal;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/BroadcastOfferModal.js